import React, { useState } from 'react';
import Toggle from '../../toggle';
import ToggleSectionLayout from './layout';
const ToggleSectionDefault = ({
  defaultValue = true,
  value = undefined,
  onChange = Function.prototype,
  ...layoutProps
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultValue);

  const isUncontrolled = value === undefined;
  const isContentVisible = isUncontrolled ? !isCollapsed : !!value;

  const handleChange = (event) => {
    if (isUncontrolled) {
      setIsCollapsed(!isCollapsed);
      onChange(!isCollapsed);
    } else {
      onChange(event.target.checked);
    }
  };

  return (
    <ToggleSectionLayout
      {...layoutProps}
      isContentVisible={isContentVisible}
      toggleSlot={
        <Toggle
          size="small"
          checked={isUncontrolled ? !isCollapsed : value}
          onChange={handleChange}
        />
      }
    />
  );
};

export default ToggleSectionDefault;
